import { IconButton, IconButtonProps } from "@material-ui/core"
import styled from "styled-components"
import MoreDetailsHoverIcon from "./icons/MoreDetailsHoverIcon"
import MoreDetailsIcon from "./icons/MoreDetailsIcon"

const StyledIconButton = styled(IconButton)`
  padding: 2px;
  svg {
    &:first-child {
      display: block;
    }
    &:last-child {
      display: none;
    }
  }
  &:hover {
    svg {
      &:first-child {
        display: none;
      }
      &:last-child {
        display: block;
      }
    }
  }
  cursor: pointer;
`
type MoreDetailsButtonProps = IconButtonProps & {
  variant?: "normal" | "dark" | "light"
}

const MoreDetailsButton = ({ ...props }: MoreDetailsButtonProps) => {
  return (
    <StyledIconButton {...props}>
      <MoreDetailsIcon />
      <MoreDetailsHoverIcon />
    </StyledIconButton>
  )
}

export default MoreDetailsButton
